<script>
import XLSX from 'xlsx'
import moment from 'moment'
import 'vue2-datepicker/index.css'
import Layout from '@layouts/main'
import appConfig from '@src/app.config'
import vue2Dropzone from 'vue2-dropzone'
import DatePicker from 'vue2-datepicker'
import { authComputed } from '@state/helpers'
import PageHeader from '@components/page-header'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { axiosGetPost } from '@router/axiosGetPost'
import StatusRq from '@/src/components/request/StatusRq'
import UploadFile from '@/src/components/request/UploadFile'
import DuplicateLog from '@/src/components/request/DuplicateLog'
import UpdateRequest from '@/src/components/request/fcl/UpdateRequest'
import PillsDuplicates from '@/src/components/request/PillsDuplicates'
import HideColumnsTable from '@components/datatablegn/HideColumnsTable'
import compareDuplicates from '@/src/components/request/compareDuplicates'
import DuplicateManually from '@/src/components/request/DuplicateManually'
import CorruptFileButton from '@/src/components/request/CorruptFileButton'
import DownloadMultipleFiles from '@/src/components/request/DownloadMultipleFiles'
import UpdateTime from '@/src/components/request/UpdateTime'

export default {
  page: {
    title: 'Requests FCL List',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    StatusRq,
    compareDuplicates,
    DuplicateManually,
    DuplicateLog,
    UploadFile,
    PillsDuplicates,
    vueDropzone: vue2Dropzone,
    HideColumnsTable,
    UpdateRequest,
    CorruptFileButton,
    DownloadMultipleFiles,
    UpdateTime,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: 'Requests',
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Requests',
          href: '/',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],
      time: 0,
      reloadTime: 900,
      timeProgressBar: 0,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: '',
      filterCarrier: '',
      filterOn: [],
      sortBy: 'id',
      sortDesc: true,
      fields: [],
      filteredItems: [],
      fieldList: [
        { key: 'id', label: 'ID', sortable: true, checkBox: true },
        {
          key: 'company_user',
          label: 'Company User',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'equipment',
          label: 'Equipment',
          sortable: true,
          checkBox: true,
        },
        { key: 'namecontract', label: 'Name', sortable: true, checkBox: true },
        { key: 'contract_code', label: 'Code', sortable: true, checkBox: true },
        {
          key: 'direction',
          label: 'Direction',
          sortable: true,
          checkBox: true,
        },
        { key: 'carriers', label: 'Carriers', sortable: true, checkBox: true },
        {
          key: 'validation',
          label: 'Validation',
          sortable: true,
          checkBox: true,
        },
        { key: 'user', label: 'User', sortable: true, checkBox: true },
        { key: 'date', label: 'Date', sortable: true, checkBox: true },
        {
          key: 'time_elapsed',
          label: 'Time Elapsed',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'username_load',
          label: 'User Load',
          sortable: true,
          checkBox: true,
        },
        {
          key: 'template',
          label: 'Notifiers',
          sortable: true,
          checkBox: false,
        },
        { key: 'status', label: 'Status', sortable: true, checkBox: false },
        { key: 'actions', label: 'Options', checkBox: false },
      ],
      requestIds: [],
      excludeFields: [],
      typeTable: 'RequestListFCL',
      dateRange: [],
      modalComponent: 'changeStatus',
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      requestIdDR: 0,
      templateData: {
        id: null,
        name: null,
        description: null,
        equipment: null,
        carrier: null,
        direction: null,
        module: null,
        request_id: null,
      },
      statusColor: {
        ['Pending']: '#f81538',
        ['Processing']: '#5527f0',
        ['Pending by Ticket']: '#ff5fa8',
        ['Imp Finished']: '#431b02',
        ['Pre-Review']: '#fd7300',
        ['Re-Processing']: '#0076ff',
        ['Review']: '#e07000',
        ['Done']: '#04950f',
      },
      equipmentColor: {
        //['DRY']: '#012586',
        ['/DRY']: '#012586',
        //['REEFER']: '#ad43ba',
        //['OPEN TOP']: '#9f9b45',
        //['FLAT RACK']: '#058b0a',
      },
      compareFilesDp_id: null,
      duplicateLogs_id: null,
      requestID: 0,
      showModal: false,
      loadingData: true,
      loadingTable: false,
      dateServer: null,
      dropzoneOptions: {
        url: process.env.VUE_APP_RUTA_API + 'requests/upload_file',
        fileName: null,
        maxFilesize: 10.0,
        dictDefaultMessage: "<i class='uil uil-cloud-upload'></i> Upload File",
        maxFiles: 1,
        addRemoveLinks: true,
        headers: {
          Authorization: this.user.token,
        },
      },
    }
  },
  watch: {
    filter(newValue) {
      localStorage.setItem('searchRequestListFcl', newValue)
    },
    filterCarrier(newValue) {
      localStorage.setItem('searchCarrierRQLFcl', newValue)
    },
  },
  computed: {
    ...authComputed,
    rows() {
      return this.tableData.length
    },
    computedFilter: function() {
      if (this.filter === null && this.filterCarrier === null) {
        return null
      }
      return [this.filter, this.filterCarrier]
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fields = this.fieldList
    this.dateRangedef()
    this.getData()
    this.totalRows = this.tableData.length
    this.interval = setInterval(() => this.increment(), 1000)
  },
  mounted() {
    // Set the initial number of items
    this.$root.$on('loadDuplicateLog', (id) => {
      this.duplicateLogModal(id)
    })

    const searchValue = localStorage.getItem('searchRequestListFcl')
    if (searchValue) {
      this.filter = searchValue
    }
    const searchCarrierV = localStorage.getItem('searchCarrierRQLFcl')
    if (searchCarrierV) {
      this.filterCarrier = searchCarrierV
    }
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.filteredItemsCustomize = filteredItems
    },
    customFilterTable(row, filter) {
      const baseFilter = filter[0].trim()
      const filterCarrier = filter[1].toLowerCase().trim()
      let rowVar = { ...row }

      if (filterCarrier) {
        const carrier = row.carriers.toLowerCase()
        if (!carrier.includes(filterCarrier)) {
          return false
        }
        delete rowVar.carriers
      }
      let valuesRow = Object.values(rowVar)
      let filtersSp = baseFilter.split(' ')
      const filtersFined = []

      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          let valRowLC = String(valRow).toLowerCase()
          let filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })
      return filtersFined.length === filtersSp.length
    },
    dateRangedef() {
      let d = moment().subtract(1, 'months')
      let d2 = moment()
      this.dateRange = [
        new Date(d.year(), d.month(), d.format('DD')),
        new Date(d2.year(), d2.month(), d2.format('DD')),
      ]
    },
    formatDate(date) {
      return date.toISOString().split('T')[0]
    },
    restore() {
      this.dateRangedef()
      this.getData()
    },
    vsuccess(file, response) {
      this.dropzoneOptions.fileName = response.file_name
    },
    removeFile() {
      const dataDic = {
        filename: this.dropzoneOptions.fileName,
      }
      axiosGetPost(
        'post',
        '/requests/delete_file',
        dataDic,
        'Drop file Dropzone Request FCL'
      ).then((response) => {
        let data = response.data
        if (data.success === true) {
          this.dropzoneOptions.fileName = null
        } else {
          this.dropzoneOptions.fileName = null
          this.$toastr.e('Error Delete in Server. Error: ' + data.error)
        }
        return data
      })
    },
    updateDataVariant() {
      // Add the key value _rowVariant: 'info' if row company_country is United States
      this.tableData.forEach((row, index) => {
        if (!['Spain', 'Portugal', 'Italy'].includes(row.company_country)) {
          this.$set(this.tableData[index], '_rowVariant', 'primary')
        }
      })
    },
    getData() {
      this.loadingTable = true
      this.time = 0
      let date = this.dateRange.map(this.formatDate)
      axiosGetPost(
        'post',
        '/requests/list',
        {
          date: date,
        },
        'Select Request List FCL'
      ).then((response) => {
        this.tableData = response.data
        this.updateDataVariant()
        this.dateServer = response.date
        this.loadingTable = false
        return response
      })
    },
    increment() {
      this.time = this.time + 1
      if (this.time === this.reloadTime) {
        this.time = 0
        this.getData()
      }
      this.timeProgressBar = (this.time * 100) / this.reloadTime
    },
    requestStatusMt(id) {
      this.loadingData = false
      this.modalErrorShow = false
      this.modalComponent = 'changeStatus'
      this.modalTitle = 'Status'
      this.showModal = true
      this.requestID = id
    },
    findIndex(id) {
      var valObj = this.tableData.findIndex(function(elem) {
        if (elem.id === id) return elem
      })
      return valObj
    },
    update_table_status(id, status, usernameLoad, contractId, lockedOptions) {
      var valObj = this.findIndex(id)
      this.tableData[valObj].status = status
      this.tableData[valObj].username_load = usernameLoad
      this.tableData[valObj].contract = contractId
      this.tableData[valObj].locked_options = lockedOptions
      this.showModal = false
    },
    update_table_duplicated(id, status, usernameLoad, lockedOptions) {
      var valObj = this.findIndex(id)
      this.tableData[valObj].status = status
      this.tableData[valObj].username_load = usernameLoad
      this.tableData[valObj].locked_options = lockedOptions
      this.tableData[valObj].duplicate = 2
      this.showModal = false
    },
    saveModal() {
      if (this.modalComponent === 'vatidateTemplateModal') {
        this.$router.push({
          name: 'spreadsheet_detail',
          params: {
            id: this.templateData.request_id,
            type: 'fcl',
          },
        })
      } else if (this.modalComponent === 'UpdateRequest') {
        this.getData()
      }
      this.showModal = false
    },
    clearRequestStatus() {
      this.requestStatus = {
        id: null,
        index: null,
        status: '',
        statusArray: [],
        userLoad: null,
      }
    },
    downloadFile(id) {
      axiosGetPost(
        'get',
        '/requests/downloadF/' + id,
        {},
        'Download File Rquests FCL, owner client'
      ).then((response) => {
        console.log(response)
        let data = response.data
        if (data.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = data.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              data.status +
              ' Error: ' +
              data.error
          )
        }

        return data
      })
    },
    compareDuplicates(id) {
      this.modalTitle = 'Possible Duplicates '
      this.modalComponent = 'compareDuplicatesModal'
      this.showModal = true
      this.loadingData = true
      this.loadingData = false
      this.compareFilesDp_id = id
    },
    updateModal: function(val) {
      this.showModal = val
    },
    duplicateManuallyModal: function(id, mode) {
      this.modalTitle = 'Duplicate Manually '
      this.modalComponent = 'duplicateManually'
      this.showModal = true
      this.loadingData = false
      this.requestID = id
    },
    updateRequestModal(id) {
      this.modalTitle = 'Update Request FCL'
      this.modalComponent = 'UpdateRequest'
      this.showModal = true
      this.loadingData = false
      this.requestID = id
    },
    duplicateLogModal: function(id = null) {
      this.modalTitle = 'Duplicate Log '
      this.modalComponent = 'DuplicateLog'
      this.showModal = true
      this.loadingData = false
      this.duplicateLogs_id = id
    },
    filterCustomn(row, filter) {
      console.log(row)
    },
    showModalUploadFile(id, detail = null) {
      this.requestID = id
      this.dropzoneOptions.detailTemplate = detail
      this.modalTitle = 'Upload file'
      this.modalComponent = 'uploadFile'
      this.showModal = true
      this.loadingData = false
    },
    verificationAccount(id) {
      axiosGetPost(
        'get',
        'requests/account_actions/' + id,
        {},
        'Verificacion de Importacion / Account FCL'
      ).then((response) => {
        let name = '/accounts'
        if (response.data === true) {
          name = '/accounts_details'
        }
        this.$router.push({ path: `${name}/${id}` })
      })
    },
    downloadFileTemplate(id) {
      axiosGetPost(
        'post',
        '/requests/downloadF/' + id,
        {},
        'Download Template Importacion FCL'
      ).then((response) => {
        let data = response.data
        var wb = XLSX.utils.book_new() // make Workbook of Excel
        var wscols = [{ wch: 25 }, { wch: 25 }, { wch: 10 }, { wch: 20 }]
        for (let i = 0; i <= Object.keys(data.table[0]).length - 4; i++) {
          // console.log(i,(data.number_cnt+3),i)
          if (i < data.number_cnt) {
            wscols.push({ wch: 7 })
          } else {
            wscols.push({ wch: 14 })
          }
        }
        var dataXLSX = XLSX.utils.json_to_sheet(data.table)
        dataXLSX['!cols'] = wscols
        XLSX.utils.book_append_sheet(wb, dataXLSX, 'Hoja1') // sheetAName is name of Worksheet
        XLSX.writeFile(wb, data.name) // name of the file is 'book.xlsx'
        return response
      })
    },
    hideRquests(id) {
      this.$swal({
        title:
          'Are you sure you want to hide this Request with ID ' +
          id +
          '? This action is irreversible.',
        showCancelButton: true,
        confirmButtonColor: 'brown',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.loadingData = true
          axiosGetPost(
            'post',
            '/requests/hiderq',
            {
              request_id: id,
            },
            'Hide Request FCL'
          ).then((response) => {
            console.log(response)
            if (response.success) {
              this.$toastr.s('Success. Request Hide')
              this.getData()
            } else {
              this.$toastr.e('Attention. Error')
            }
            return response
          })
        } else {
          this.$swal('Cancelled')
        }
      })
    },
    onAction(id, action) {
      let data = 'actions_dropdown_' + id
      let triger = this.$refs[data]
      triger.visible = action == 'over' ? true : false
    },
    updateTableFieldsEmit(fields) {
      this.fields = fields
    },
    selectAllOnPage() {
      let itemsToSelect = []
      const startIndex = (this.currentPage - 1) * this.perPage
      const endIndex = startIndex + this.perPage
      let data =
        this.filteredItemsCustomize.length > 0
          ? this.filteredItemsCustomize
          : this.tableData
      itemsToSelect = data.slice(startIndex, endIndex)
      let is_any_true = itemsToSelect.some((item) => item.checked == true)
      itemsToSelect.forEach((item) => (item.checked = !is_any_true))
    },
    getElementsTable() {
      let ids = []
      this.tableData.forEach((element, index) => {
        if (element.checked === true) {
          ids.push(element['id'])
        }
      })
      if (ids.length == 0) {
        this.$toastr.e(
          'Attention. Error. You have to select 1 or more elements'
        )
        return []
      }
      return ids
    },
    downloadMultiplesFiles(id) {
      this.requestIds = []
      this.requestIds = this.getElementsTable()
      if (this.requestIds.length >= 1) {
        this.modalTitle = 'Download Multiple Files'
        this.modalComponent = 'DownloadMultipleFiles'
        this.showModal = true
        this.loadingData = true
        this.loadingData = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-md-2">
              <div class="col-sm-3 col-md-8 text-md-left">
                <h4 class="header-title mt-0 mb-1">Request FCL List</h4>
              </div>
              <div class="col-sm-3 col-md-4 text-md-left">
                <p class="text-muted font-13 mb-4">
                  <b-progress
                    :value="timeProgressBar"
                    :max="100"
                    class="mb-3"
                    variant="primary"
                    show-value
                  >
                  </b-progress>
                </p>
              </div>
            </div>
            <div class="row mb-md-2">
              <div class="col-sm-8 col-md-8 text-md-left">
                <date-picker
                  v-model="dateRange"
                  @change="getData"
                  class="col-5"
                  type="date"
                  range
                  placeholder="Select date range"
                >
                </date-picker>
                <b-button
                  class="btn btn-primary col-md-2"
                  variant="primary"
                  @click="getData"
                  >Update</b-button
                >&nbsp;
                <b-button
                  class="btn btn-primary col-md-2"
                  variant="primary"
                  @click.prevent="restore"
                  >Restore</b-button
                >
              </div>
              <div class="col-sm-4 col-md-4 text-md-right">
                <b-button
                  class="btn btn-primary col-md-5"
                  variant="primary"
                  @click="duplicateLogModal(0)"
                  >Duplicate Log
                </b-button>
              </div>
            </div>
            <div class="d-flex mb-md-2">
              <div class="mr-auto">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries
                </label>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Multiple Edition"
                  @click="selectAllOnPage()"
                  >Select All / Unselect &nbsp;
                  <i class="uil uil-check"></i> </button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Multiple Edition"
                  @click="downloadMultiplesFiles"
                  >Download Files &nbsp;
                  <i class="uil uil-cloud.down"></i> </button
                >&nbsp;
              </div>
              <div>
                <HideColumnsTable
                  :field-list-fth="fieldList"
                  :type-table="typeTable"
                  @updateTableFieldsEmit="updateTableFieldsEmit"
                />
              </div>
              <!-- Carrier Filter -->
              <div>
                <label class="d-inline-flex align-items-center">
                  Carrier:
                  <b-form-input
                    v-model="filterCarrier"
                    type="search"
                    placeholder="Carrier..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
                &nbsp; &nbsp;
              </div>
              <!-- End Carrier Filter -->

              <!-- Search -->
              <div>
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 table-responsive-list-menu">
              <b-table
                striped
                hover
                :items="tableData"
                :fields="fields"
                :busy="loadingTable"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="computedFilter"
                :filter-included-fields="filterOn"
                :filter-function="customFilterTable"
                @filtered="onFiltered"
              >
                <template v-slot:table-busy>
                  <div
                    class="row align-items-center justify-content-center"
                    style="height: 150px"
                  >
                    <div class="col-12 col-md-8 text-center">
                      <b-spinner
                        label="Loading..."
                        variant="primary"
                        class="ml-3"
                      ></b-spinner>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(id)="row">
                  <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
                  <b-form-checkbox v-model="row.item.checked">
                    {{ row.item.id }}
                  </b-form-checkbox>
                </template>
                <template v-slot:cell(time_elapsed)="row">
                  <span v-if="row.item.status !== 'Done'">
                    <UpdateTime
                      :date-time="row.item.date"
                      :date-server="dateServer"
                    />
                  </span>
                  <span v-else style=""
                    >{{ row.item.time_elapsed }} <br />
                  </span>
                </template>
                <template v-slot:cell(company_user)="row">
                  <span
                    class="badge"
                    :class="`badge-tier-${row.item.tier || 3}`"
                    :title="`Tier ${row.item.tier || 3}`"
                    >{{ row.item.company_user }} <br />
                  </span>
                  <br />
                  <span
                    v-if="row.item.company_country !== null"
                    class="badge"
                    :class="`badge-country`"
                    :title="`Tier ${row.item.tier || 3}`"
                    style="color: #1DD792"
                    >{{ row.item.company_country }} <br />
                  </span>
                </template>
                <template v-slot:cell(status)="row">
                  <a
                    v-if="row.item.erased_contract === 0"
                    href="#"
                    @click="requestStatusMt(row.item.id)"
                  >
                    <span
                      :style="{ color: statusColor[row.item.status] }"
                      style="font-weight: bold"
                      >{{ row.item.status }} <br />
                      <small
                        v-if="row.item.bc_rq_mappin_status === 1"
                        class="parpadea"
                        style="color: #c19b00"
                        >Incomplete mapping</small
                      >
                    </span>
                  </a>
                  <a
                    v-else-if="row.item.erased_contract === 1"
                    href="#"
                    title="Contract Deleted By Customer"
                  >
                    <span
                      :style="{ color: statusColor[row.item.status] }"
                      style="font-weight: bold"
                      >{{ row.item.status }}
                      <span
                        class="uil uil-lock-alt"
                        style="color: #f81538"
                      ></span
                      ><br />
                      <small style="color: #f81538"
                        >Contract Deleted By Customer</small
                      ></span
                    >
                  </a>
                </template>
                <template v-slot:cell(equipment)="row">
                  <a v-bind:title="row.item.equipment">
                    <span
                      :class="row.item.equipment"
                      :style="{ color: equipmentColor[row.item.equipment] }"
                      style="font-weight: bold"
                      >{{ row.item.containers }}</span
                    >
                  </a>
                </template>
                <template v-slot:cell(actions)="row">
                  <div>
                    <b-dropdown
                      variant="success"
                      dropleft
                      class="ml-1 btn-sm"
                      :ref="`actions_dropdown_${row.item.id}`"
                    >
                      <template slot="button-content">
                        <i
                          class="uil uil-angle-double-left"
                          style="color: #278c27"
                        ></i>
                        <i v-if="row.item.erased_contract === 0">Options</i>
                        <i
                          v-if="row.item.erased_contract === 1"
                          style="color: #f81538"
                          title="Contract Deleted By Customer"
                          ><strong> Erased</strong></i
                        >
                      </template>
                      <div v-if="row.item.locked_options == 0">
                        <b-dropdown-item
                          v-if="
                            ['Reviewing', 'Pre-Review', 'Done'].includes(
                              row.item.status
                            )
                          "
                          href="#"
                          :to="{
                            name: 'reviews_module',
                            params: {
                              id: row.item.id,
                              module: 'fcl',
                            },
                          }"
                        >
                          <span style="color: #d9b400">
                            <i class="uil uil-file-check-alt"></i>
                            &nbsp; &nbsp; Review Suggestions New
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="row.item.status != 'Pending'"
                          href="#"
                          @click="verificationAccount(row.item.id)"
                        >
                          <span style="color: rgb(86 21 21)">
                            <i class="uil uil-file-check-alt"></i>
                            &nbsp; &nbsp; Import Contract
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            [
                              'Imp Finished',
                              'Re-Processing A.',
                              'Reviewing',
                              'Pre-Review',
                              'Done',
                            ].includes(row.item.status)
                          "
                          href="#"
                          :to="{
                            name: 'goodandfails',
                            params: {
                              id: row.item.id,
                              module: 'fcl',
                            },
                          }"
                        >
                          <span style="color: rgb(15, 118, 118)">
                            <i class="uil uil-atm-card"></i>
                            &nbsp; &nbsp; Good & Fail
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item
                          href="#"
                          @click="downloadFileTemplate(row.item.id)"
                        >
                          <span style="color: #9a028e">
                            <i class="uil uil-file-times"></i>
                            &nbsp; &nbsp; Download Template
                          </span>
                        </b-dropdown-item>
                        <!-- <b-dropdown-item
                          href="#"
                          @click="validateTemplate(row.item.id)"
                        >
                          <span
                            style="color: #41a52f"
                            :class="{
                              parpadea: row.item.bc_rq_mappin_status === 1,
                            }"
                          >
                            <i class="uil uil-robot"></i>
                            &nbsp; &nbsp; Search Template
                          </span>
                        </b-dropdown-item> -->
                        <CorruptFileButton
                          v-if="['Reviewing'].includes(row.item.status)"
                          :status="row.item.is_corrupt_file"
                          :model-id="row.item.id"
                          module="fcl"
                          @updateStatus="getData"
                        >
                        </CorruptFileButton>
                        <!-- <b-dropdown-item
                          v-if="
                            row.item.template === 1 &&
                              row.item.status !== 'Review' &&
                              row.item.status !== 'Done'
                          "
                          href="#"
                          :to="{
                            name: 'spreadsheet_detail',
                            params: {
                              id: row.item.id,
                              type: 'fcl',
                            },
                          }"
                        >
                          <span
                            style="color: rgb(87 17 162)"
                            :class="{
                              parpadea: row.item.bc_rq_mappin_status === 1,
                            }"
                            ><i class="uil uil-analysis"></i>&nbsp; &nbsp;
                            Template Found</span
                          >
                        </b-dropdown-item> -->
                        <b-dropdown-item
                          href="#"
                          style="color: ##0a399a"
                          @click="compareDuplicates(row.item.id)"
                        >
                          <span style="color: rgb(1 38 113)">
                            <i class="uil uil-file-search-alt"></i>
                            &nbsp; &nbsp; Compare Duplicates
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item
                          href="#"
                          style="color: ##0a399a"
                          @click="duplicateManuallyModal(row.item.id, 'FCL')"
                        >
                          <span style="color: rgb(1 38 113)"
                            ><i class="uil uil-file-search-alt"></i>&nbsp;
                            &nbsp; Duplicate manually</span
                          >
                        </b-dropdown-item>
                        <b-dropdown-item
                          href="#"
                          style="color: ##0a399a"
                          @click="showModalUploadFile(row.item.id)"
                        >
                          <span style="color: rgb(1 38 113)">
                            <i class="uil uil-cloud-upload"></i>
                            &nbsp; &nbsp;Upload File S.S.
                          </span>
                        </b-dropdown-item>
                      </div>
                      <b-dropdown-item
                        href="#"
                        style="color: ##0a399a"
                        @click="downloadFile(row.item.id)"
                      >
                        <span style="color: rgb(1 38 113)"
                          ><i class="uil uil-cloud-download"></i>&nbsp; &nbsp;
                          Download File</span
                        >
                      </b-dropdown-item>
                      <b-dropdown-item
                        href="#"
                        style="color: ##0a399a"
                        v-if="row.item.status !== 'Done'"
                        @click="updateRequestModal(row.item.id)"
                      >
                        <span style="color: rgb(1 38 113)"
                          ><i class="uil uil-file-edit-alt"></i>&nbsp; &nbsp;
                          Edit Request</span
                        >
                      </b-dropdown-item>
                      <CorruptFileButton
                        v-if="'Reviewing' !== row.item.status"
                        :status="row.item.is_corrupt_file"
                        :model-id="row.item.id"
                        module="fcl"
                        @updateStatus="getData"
                      >
                      </CorruptFileButton>
                      <b-dropdown-item
                        href="#"
                        style="color: rgb(248, 21, 56)"
                        v-if="row.item.erased_contract === 1"
                        @click="hideRquests(row.item.id)"
                      >
                        <span style="color: rgb(248, 21, 56)">
                          <i class="uil uil-eye-slash"></i>
                          &nbsp; &nbsp;Hide Request
                        </span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </template>

                <template v-slot:cell(template)="row">
                  <a v-if="row.item.modified_by_user">
                    <span class="badge badge-soft-danger"
                      >Modified by user</span
                    >
                  </a>
                  <a :href="'#'" @click="compareDuplicates(row.item.id)">
                    <PillsDuplicates :item-row="row.item" />
                  </a>

                  <a :href="'#'">
                    <span
                      v-if="
                        row.item.is_readed_queue === 0 &&
                          row.item.in_queue === 0
                      "
                      class="badge"
                      :class="{
                        'badge-soft-danger':
                          row.item.is_readed_queue === 0 &&
                          row.item.in_queue === 0,
                      }"
                      >Review Available</span
                    >
                  </a>
                  <span v-if="row.item.is_corrupt_file" style="color: red">
                    <i class="uil uil-file-search-alt"></i>
                    E. Corrupt File
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <strong>Filtered {{ totalRows }} of {{ rows }} entries</strong>
                <div
                  class="dataTables_paginate paging_simple_numbers float-lefts"
                >
                </div>
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Cambio de status -->
      <!-- <b-button variant="success" @click="test">methods</b-button> -->
      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>

        <compareDuplicates
          v-else-if="modalComponent === 'compareDuplicatesModal'"
          :request-id="compareFilesDp_id"
          type="FCL"
          @ev_update_fields="update_table_duplicated"
        />
        <DuplicateManually
          v-else-if="modalComponent === 'duplicateManually'"
          :request-id="requestID"
          :mode="'FCL'"
          @ev_update_fields="update_table_duplicated"
        />
        <DuplicateLog
          v-else-if="modalComponent === 'DuplicateLog'"
          :request-id="duplicateLogs_id"
          type="FCL"
        />
        <DownloadMultipleFiles
          v-else-if="modalComponent === 'DownloadMultipleFiles'"
          :request-ids="requestIds"
          module="FCL"
        />
        <StatusRq
          v-else-if="modalComponent === 'changeStatus'"
          :request-id="requestID"
          mode="FCL"
          @update_table_row="update_table_status"
        />
        <UploadFile
          v-else-if="modalComponent === 'uploadFile'"
          :dz-options="dropzoneOptions"
          :request-id="requestID"
        />

        <UpdateRequest
          v-else-if="modalComponent === 'UpdateRequest'"
          :request-id="requestID"
          @close_modal="saveModal"
        />

        <template v-slot:modal-footer>
          <b-button variant="light" @click="$refs.requestFcl.hide"
            >Close</b-button
          >
          <b-button
            v-if="
              loadingData === false &&
                modalErrorShow === false &&
                ![
                  'uploadFile',
                  'UpdateRequest',
                  'duplicateManually',
                  'changeStatus',
                  'duplicateLog',
                ].includes(modalComponent)
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>

<style>
/*.dropdown-menu {
    position:static !important
}*/

/*body {
  --table-width: 100%;
}
tbody {
  display:block;
  max-height:500px;
  overflow-y:auto;
}
thead, tbody tr {
  display:table;
  width: var(--table-width);
  table-layout:fixed;
}*/

.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.badge-country {
  color: #ffffff !important;
  background-color: #1dd792;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}

.parpadea {
  animation-name: parpadeo;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;

  -webkit-animation-name: parpadeo;
  -webkit-animation-duration: 2s;
  -webkit-animation-timing-function: linear;
  -webkit-animation-iteration-count: infinite;
}

@-moz-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes parpadeo {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
